import React from "react";
import LiveMatchSummaryWide from "./LiveMatchSummaryWide";
import { getPrettyDate } from "../lib/format";
import { poolPrefix, not_started, status_color, std_outcome, fourone_outcome, scores_outcome } from "./liveOutcomes";

const manage_closing_time_error = (programDate, kickOffTime, PartitionKey, RowKey) => {
  if (PartitionKey === "ErrorPart" && RowKey === "ErrorRow") {
    return "Sun 1 Dec 15:30";
  } else {
    return getPrettyDate(programDate) + " " + kickOffTime;
  }
};
const getProperPoolName = (PartitionKey) => {
  const poolMap = {
    S1: "Soccer 1",
    S4: "Soccer 4",
    SC: "Soccer Corners",
    S6: "Soccer 6",
    SS: "Soccer Scores",
    S10: "Soccer 10",
    S11: "Mega 10 Jackpot",
    S13: "Soccer 13",
    S16: "Any 13 Xtra",
  };
  return PartitionKey.replace(/^S(?:\d+|[CS])/, (match) => poolMap[match] || match);
};

const projected_result = (match, venue, index) => {
  switch (poolPrefix(venue)) {
    case "SS":
      return projected_scores_result(match, index);
    case "S4":
    case "S1":
      return projected_fourone_result(match, index);
    case "SC":
      return "?";
    case "S8":
      // index is not passed on, so every Soccer 8 match is shown after a "/".
      return projected_eight_result(match);
    default:
      return projected_std_result(match, index);
  }
};

// One match in the Projected Combination: the first stands alone, the rest follow a "/".
const projection = (index, mark) => {
  if (index === 0) {
    return mark;
  }
  return (
    <>
      <span>/</span>
      {mark}
    </>
  );
};

// A finished match's outcome is final (darkslateblue), a match in play is projected (tomato).
const outcome = (value, color) => <span style={{ fontWeight: "bold", color, display: "inline" }}>{value}</span>;
const not_started_mark = <span style={{ display: "inline" }}>-</span>;

const projected_std_result = (match, index) => {
  if (not_started(match)) {
    return projection(index, not_started_mark);
  }
  return projection(index, outcome(std_outcome(parseInt(match.home_score), parseInt(match.away_score)), status_color(match)));
};

// Soccer 8 HF: odd matches are full-time results, even matches half-time results.
const projected_eight_result = (match, index) => {
  if (index === 1 || index === 3 || index === 5 || index === 7) {
    return projection(index, outcome(std_outcome(parseInt(match.home_score), parseInt(match.away_score)), status_color(match)));
  }
  if (match.home_ht_score.length > 0) {
    // after half time - use ht as finalised
    return projection(index, outcome(std_outcome(parseInt(match.home_ht_score), parseInt(match.away_ht_score)), "darkslateblue"));
  }
  // before half time - use live score as projected
  return projection(index, outcome(std_outcome(parseInt(match.home_score), parseInt(match.away_score)), "tomato"));
};

const projected_fourone_result = (match, index) => {
  if (not_started(match)) {
    return projection(index, not_started_mark);
  }
  const value = fourone_outcome(parseInt(match.home_score), parseInt(match.away_score));
  if (value === undefined) {
    return undefined;
  }
  return projection(index, outcome(value, status_color(match)));
};

const projected_scores_result = (match, index) => {
  if (not_started(match)) {
    return projection(index, not_started_mark);
  }
  return projection(index, outcome(scores_outcome(parseInt(match.home_score), parseInt(match.away_score)), status_color(match)));
};

// The Results page each Pool Type links to. Mega 10 Jackpot (S11) has none.
const results_pages = {
  S1: ["soccer-1", "Soccer 1"],
  S10: ["soccer-10", "Soccer 10"],
  S13: ["soccer-13", "Soccer 13"],
  S13X: ["soccer-13-extra", "Soccer Any 13 Xtra"],
  S4: ["soccer-4", "Soccer 4"],
  S6: ["soccer-6", "Soccer 6"],
  S8: ["soccer-8", "Soccer 8 HF"],
  SS: ["soccer-5", "Soccer Scores"],
  SC: ["soccer-7", "Soccer Corners"],
};

const get_results_link = (venue) => {
  const page = results_pages[poolPrefix(venue)];
  if (page === undefined) {
    return undefined;
  }
  const [slug, name] = page;
  return (
    <a href={"../results-and-payouts/" + slug} style={{ color: "#001489" }}>
      {name + " Results Page"}
    </a>
  );
};

const LivePoolItemWide = ({ item }) => {
  return (
    <div>
      <div className="pooldateindicator4R">
        {getPrettyDate(item.programDate)} - {getProperPoolName(item.PartitionKey)}
      </div>
      <table style={{ width: "100%", maxWidth: "100%", display: "block", overflowX: "auto" }}>
        <tbody>
          <tr>
            <th style={{ width: "3%" }} className="centertext">
              M#
            </th>
            <th style={{ width: "8%" }} className="centertext">
              Time
            </th>
            <th style={{ width: "3%" }} className="centertext">
              Proj
            </th>
            <th style={{ width: "37%" }} className="centertext">
              Team A
            </th>
            <th style={{ width: "12%" }} className="centertext">
              Score
            </th>
            <th style={{ width: "37%" }} className="centertext">
              Team B
            </th>
          </tr>
          {JSON.parse(item.matches).map((match) => (
            <LiveMatchSummaryWide item={match} pool_title={item.PartitionKey} />
          ))}
        </tbody>
      </table>
      <div className="panel poolinformation">
        {item.poolStatus === "OPEN" ? (
          <>
            Current Pool: {item.poolTotal}
            <br />
            Closes: {manage_closing_time_error(item.programDate, item.kickOffTime)}
          </>
        ) : (
          <>Closing Pool: {item.poolTotal}</>
        )}
        <br />
        Status: {item.poolStatus}. Pool Code {item.programCode}
        <br />
        {item.poolStatus === "OPEN" ? (
          <a
            href={"https://www.tab.co.za/tabs/soccer/" + item.programDate + "/" + item.programCode + "/" + item.race}
            className="button button4R tiny right betnowbutton"
            target="_blank"
            rel="noopener noreferrer"
          >
            BET NOW
          </a>
        ) : (
          <>
            Projected Combination: {JSON.parse(item.matches).map((match, index) => projected_result(match, item.PartitionKey, index))}
            <br />
            <span style={{ color: "lightslategrey", fontSize: "0.75em", fontWeight: "normal" }}>
              NB: All projected results are provisional - please use the {get_results_link(item.PartitionKey)} for official results &amp; payouts.
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default LivePoolItemWide;
